import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'out-input',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss',
})
export class InputComponent implements OnInit, OnDestroy {
  @Input() id = '';
  @Input() name = '';
  @Input() label = '';
  @Input() required = false;
  @Input() validation = [];
  @Input() value: string | number | null = '';
  @Input() disabled = false;
  @Input() placeholder = '';
  @Input() type = 'text';
  @Input() readonly = false;
  @Input() autocomplete = 'off';
  @Input() errorMessage = '';
  @Input() control!: FormControl;
  @Input() acl = '';

  @Output() valueChange = new EventEmitter<string | number>();

  private subscription!: Subscription;

  ngOnInit() {
    if (this.control) {
      this.subscription = this.control.valueChanges.subscribe((value) => {
        this.valueChange.emit(value);
      });
    }
  }

  ngOnDestroy() {
    // Unsubscribe to prevent memory leaks
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  hasError(): boolean {
    return this.control.invalid && (this.control.touched || this.control.dirty);
  }
}
